// extracted by mini-css-extract-plugin
export default {"form":"FormAddProduct_form__-ypev","actions":"FormAddProduct_actions__TcQ6C","btn":"FormAddProduct_btn__1FTMi"};